"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const Pagination_form_1 = __importDefault(require("./Pagination.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const formUtils_1 = require("../../../utils/formUtils");
const Utils = __importStar(require("../../../utils/utils"));
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class PaginationComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.checks = [];
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'pagination',
            label: 'Pagination',
            pageCount: 0,
            pageIndex: 1,
            pageSize: 15,
            allowChangePageSize: true,
            addFirstLastBtn: true,
            displayInfo: true,
            gotoPage: 0,
            previousName: '&lsaquo;',
            fistName: '&laquo;',
            nextName: '&rsaquo;',
            lastName: '&raquo;',
            align: 'justify-content-start',
            numBtn: 5,
            action: 'event'
        }, ...extend);
    }
    get defaultSchema() {
        return PaginationComponent.schema();
    }
    get defaultValue() {
        return {
            pageCount: this.component.pageCount,
            pageIndex: this.component.pageIndex,
            pageSize: this.component.pageSize
        };
    }
    get total() {
        return this.component.total ? this.component.total : this.component.pageSize * this.component.pageCount;
    }
    get emptyValue() {
        return this.getValue();
    }
    get pageArr() {
        var arr = [];
        if (this.component.addFirstLastBtn) {
            arr.push({ key: 'first', value: 1, text: this.component.firstName || `<i class="bi bi-chevron-double-left"></i>` });
        }
        arr.push({ key: 'prev', value: 0, text: this.component.previousName || `<i class="bi bi-chevron-left"></i>` });
        var btnCount = this.component.numBtn === 0 ? this.component.pageCount : this.component.numBtn;
        var absBtn = Math.trunc(btnCount / 2);
        var start = 1, end = 0;
        if (this.component.pageCount <= btnCount) {
            start = 1;
            end = this.component.pageCount;
        }
        else {
            start = this.component.pageIndex > absBtn ? this.component.pageIndex - absBtn : 1;
            end = this.component.pageIndex < this.component.pageCount - absBtn ? this.component.pageIndex + absBtn : this.component.pageCount;
        }
        if (end - start < btnCount - 1 && btnCount < this.component.pageCount) {
            if (start > this.component.pageIndex - absBtn) {
                end += start - (this.component.pageIndex - absBtn);
            }
            else {
                start -= btnCount - 1 - (end - start);
            }
        }
        if (start > 1) {
            arr.push({ key: 'arrPrev', value: 0, text: '...' });
        }
        for (let i = start; i <= end; i++) {
            if (this.component.notshowPageNumber !== true) {
                arr.push({ key: `aaa${i}`, value: i, text: i });
            }
        }
        if (end < this.component.pageCount) {
            arr.push({ key: 'arrNext', value: 0, text: '...' });
        }
        arr.push({ key: 'next', value: 0, text: this.component.nextName || `<i class="bi bi-chevron-right"></i>` });
        if (this.component.addFirstLastBtn) {
            arr.push({ key: 'last', value: this.component.pageCount, text: this.component.lastName || `<i class="bi bi-chevron-double-right"></i>` });
        }
        arr.push({ key: 'select', value: this.component.pageSize, text: 'Rows per page:' });
        return arr;
    }
    inputInfoBtn(index) {
        const info = super.elementInfo();
        info.type = 'button';
        info.ref = `${this.component.key}-${index.key}`;
        info.attr.type = 'button';
        this.component.theme = this.component.theme || 'btn page-link';
        if (index.value === this.component.pageIndex && !['first', 'last'].includes(index.key)) {
            info.attr.class = this.component.themeActive ? this.component.themeActive : 'btn page-link active';
            info.attr.disabled = true;
        }
        else {
            info.attr.class = this.component.theme;
        }
        if (this.component.size) {
            info.attr.class += ` btn-${this.component.size}`;
        }
        if (this.component.customClass) {
            info.attr.class += ` ${this.component.customClass}`;
        }
        info.content = index.text;
        return info;
    }
    renderItem(itemNumber) {
        var input = this.inputInfoBtn(itemNumber);
        return this.renderTemplate('input', {
            input: input
        });
    }
    render() {
        var view = '';
        var toValue = this.component.pageIndex * this.component.pageSize;
        toValue = toValue > this.total ? this.total : toValue;
        view += `<div class='d-flex ${this.component.align} ari-items-center ari-gap-3'><nav aria-label="Page navigation" class="d-inline-block">`;
        if (this.component.pageCount > 0) {
            view += `<ul class="pagination ${this.component.align === 'left' ? '' : this.component.align}">
        ${this.renderPageButtons()}
      </ul>`;
        }
        view += `</nav>${this.renderSelect()}`;
        if (this.component.displayInfo) {
            view += `<div class='d-flex ${this.component.align}'>
      ${(this.component.pageIndex - 1) * this.component.pageSize + 1} - ${toValue} of ${this.total}
    </div> </div>`;
        }
        return super.render(view);
    }
    renderPageButtons() {
        let buttonViews = '';
        var arr = this.pageArr;
        arr.forEach(item => {
            if (item.key !== 'select') {
                if (item.key === 'prev') {
                    buttonViews += `<li class="page-item ${this.component.pageIndex === 1 ? 'disabled' : ''}">`;
                }
                else if (item.key === 'next') {
                    buttonViews += `<li class="page-item ${this.component.pageIndex === this.component.pageCount ? 'disabled' : ''}">`;
                }
                else {
                    buttonViews += `<li class="page-item ${this.component.pageIndex === item.value && !['first', 'last'].includes(item.key) ? 'active' : ''}">`;
                }
                buttonViews += `${this.renderItem(item)}</li>`;
            }
        });
        return buttonViews;
    }
    get optionPagination() {
        return [
            { value: 15, label: '15', selected: this.component.pageSize === 15 || this.component.pageSize === '15' },
            { value: 30, label: '30', selected: this.component.pageSize === 30 || this.component.pageSize === '30' },
            { value: 50, label: '50', selected: this.component.pageSize === 50 || this.component.pageSize === '50' },
            { value: 100, label: '100', selected: this.component.pageSize === 100 || this.component.pageSize === '100' },
        ];
    }
    renderSelect() {
        if (this.component.allowChangePageSize) {
            const info = super.elementInfo();
            info.type = 'select';
            info.attr.class = 'form-control ari-h-[35px]';
            info.changeEvent = 'change';
            //HungNQ  Bypass error pagination-select by edit form bootstrap
            info.ref = `${this.component.key}-select`;
            //End HungNQ
            var select = `<div class="ari-flex ari-items-center ari-gap-2">
      <label class="col-form-label"> ${Utils.getLangText('Rows per page:')}</label>
      <div class="ari-w-[80px]">
          ${this.renderTemplate('select', {
                input: info,
                selectOptions: this.optionPagination.reduce((html, option) => html + this.renderTemplate('selectOption', {
                    option,
                    selected: option.selected,
                    attrs: {}
                }), ''),
            })}
      </div>
    </div>`;
            return select;
        }
        return '';
    }
    bindData(pageCount, total, pageIndex) {
        this.component.pageCount = pageCount;
        this.component.total = total ? total : pageCount * this.component.pageSize;
        this.component.pageIndex = pageIndex ? pageIndex : this.component.pageIndex;
        this.component.pageSize = total === 0 ? 15 : this.component.pageSize;
        this.updateValue();
        this.redraw();
    }
    getValue() {
        var value = {
            pageCount: this.component.pageCount,
            pageIndex: this.component.pageIndex,
            pageSize: this.component.pageSize
        };
        return value;
    }
    changeIndex(input, event, pageCount, pageIndex) {
        this.addEventListener(input, event, () => {
            if (event === 'change') {
                this.component.pageSize = input.value;
            }
            if (this.component.pageCount === 0) {
                this.bindData(pageCount, this.component.total, pageIndex);
                return;
            }
            this.bindData(pageCount, this.component.total, pageIndex);
            //if (this.component.pageCount > 0) {
            switch (this.component.action) {
                case 'event':
                    this.emit(this.interpolate(this.component.event), this.data);
                    this.events.emit(this.interpolate(this.component.event), this.data);
                    var clickEvent = new Event(event);
                    this.emit('customEvent', {
                        type: this.interpolate(this.component.event),
                        component: this.component,
                        data: this.data,
                        event: clickEvent
                    });
                    break;
                case 'custom': {
                    // Get the AriFormForm at the root of this component's tree
                    const form = this.getRoot();
                    // Get the form's flattened schema components
                    const flattened = (0, formUtils_1.flattenComponents)(form.component.components, true);
                    // Create object containing the corresponding HTML element components
                    const components = {};
                    lodash_1.default.each(flattened, (component, key) => {
                        const element = form.getComponent(key);
                        if (element) {
                            components[key] = element;
                        }
                    });
                    this.evaluate(this.component.custom, {
                        form,
                        flattened,
                        components
                    });
                    this.triggerChange();
                    break;
                }
            }
            //}
        });
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var refs = {};
        const arr = this.pageArr;
        for (let i = 0; i < arr.length; i++) {
            refs[`${this.component.key}-${arr[i].key}`] = 'multiple';
        }
        this.loadRefs(element, refs);
        this.checks = [];
        for (let i = 0; i < arr.length; i++) {
            this.checks[i] = Array.prototype.slice.call(this.refs[`${this.component.key}-${arr[i].key}`], 0);
            // Attach click events to each button
            this.checks[i].forEach(input => {
                if (arr[i].key === 'select') {
                    this.changeIndex(input, 'change', 0, 1);
                }
                else if (arr[i].key === 'prev') {
                    this.changeIndex(input, 'click', this.component.pageCount, this.component.pageIndex - 1);
                }
                else if (arr[i].key === 'next') {
                    this.changeIndex(input, 'click', this.component.pageCount, this.component.pageIndex + 1);
                }
                else if (this.component.pageIndex !== arr[i].value) {
                    this.changeIndex(input, 'click', this.component.pageCount, arr[i].value);
                }
            });
        }
        // Allow basic component functionality to attach like field logic and tooltips.
        return super.attach(element);
    }
}
PaginationComponent.editForm = Pagination_form_1.default;
PaginationComponent.builderInfo = {
    title: 'Pagination',
    group: 'basic',
    icon: 'fast-forward',
    weight: 70,
    documentation: 'http://help.ari.form/userguide/',
    schema: PaginationComponent.schema()
};
exports.default = PaginationComponent;
